export default "__VITE_ASSET__Ei1XbtAe__"